import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useState } from 'react';
import { useBuilder } from '../../../store/provider';
import DiffViewContext from '../utils/diff-view-context';
import PercyFooter from './percy-footer';
import SuggestionShell from './suggestion-shell';
type PatchCardProps = {
  suggestionId: string;
  note: string;
  isStale?: boolean;
  title?: ReactNode;
  subtype?: string;
  showDiffToggle?: boolean;
  children?: ReactNode;
};
const PatchCard = t0 => {
  const $ = _c(27);
  const {
    suggestionId,
    note,
    isStale,
    title,
    subtype,
    showDiffToggle,
    children
  } = t0;
  const {
    acceptSuggestions,
    rejectSuggestions,
    isSavingGraph
  } = useBuilder();
  const [showDiff, setShowDiff] = useState(true);
  let t1;
  if ($[0] !== showDiff) {
    t1 = {
      showDiff
    };
    $[0] = showDiff;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== subtype || $[3] !== title) {
    t2 = (title || subtype) && <div className="flex flex-wrap items-baseline gap-2 md:flex-nowrap">{title && <span className="text-snippet-2 text-primary wrap-anywhere md:wrap-normal">{title}</span>}{subtype && <span className="text-snippet-3 text-tertiary">{subtype}</span>}</div>;
    $[2] = subtype;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== acceptSuggestions || $[6] !== suggestionId) {
    t3 = () => acceptSuggestions([suggestionId]);
    $[5] = acceptSuggestions;
    $[6] = suggestionId;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== rejectSuggestions || $[9] !== suggestionId) {
    t4 = () => rejectSuggestions([suggestionId]);
    $[8] = rejectSuggestions;
    $[9] = suggestionId;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== isSavingGraph || $[12] !== isStale || $[13] !== note || $[14] !== showDiff || $[15] !== showDiffToggle || $[16] !== t3 || $[17] !== t4) {
    t5 = <PercyFooter note={note} isStale={isStale} onAccept={t3} onDismiss={t4} isPending={isSavingGraph} showDiffToggle={showDiffToggle} showDiff={showDiff} onToggleDiff={setShowDiff} />;
    $[11] = isSavingGraph;
    $[12] = isStale;
    $[13] = note;
    $[14] = showDiff;
    $[15] = showDiffToggle;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== children || $[20] !== t1 || $[21] !== t2 || $[22] !== t5) {
    t6 = <DiffViewContext.Provider value={t1}>{t2}{children}{t5}</DiffViewContext.Provider>;
    $[19] = children;
    $[20] = t1;
    $[21] = t2;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== suggestionId || $[25] !== t6) {
    t7 = <SuggestionShell suggestionId={suggestionId}>{t6}</SuggestionShell>;
    $[24] = suggestionId;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
};
export default PatchCard;